import styled from 'react-emotion';
import { theme, icons } from '@ublend-npm/aulaui-next';

export const AlertTextWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  flex-grow: 1;
  white-space: nowrap;
`;

export const BoldText = styled('span')`
  font-weight: ${theme.font.weight.medium};
`;

export const CustomSlideShowIcon = styled(icons.SlideshowIcon)`
  font-size: 18px;
`;

export const Link = styled('a')`
  color: ${theme.color.designSystem.purple70};
  font-size: ${theme.font.size.copy};
  font-weight: ${theme.font.weight.medium};
  line-height: 16px;
  text-decoration: none;
  cursor: pointer;
  margin-left: 28px;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;
